var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666016 6.66675C0.666016 3.35304 3.35231 0.666748 6.66602 0.666748C9.97972 0.666748 12.666 3.35304 12.666 6.66675C12.666 8.08342 12.175 9.38542 11.3539 10.4119L15.6088 14.6667L14.666 15.6096L10.4111 11.3547C9.38469 12.1758 8.08269 12.6667 6.66602 12.6667C3.35231 12.6667 0.666016 9.98046 0.666016 6.66675ZM6.66602 2.00008C4.08869 2.00008 1.99935 4.08942 1.99935 6.66675C1.99935 9.24408 4.08869 11.3334 6.66602 11.3334C9.24334 11.3334 11.3327 9.24408 11.3327 6.66675C11.3327 4.08942 9.24334 2.00008 6.66602 2.00008Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3fc53a1e803c38f38ce704882212a041.svg";
export { ForwardRef as ReactComponent };